// extracted by mini-css-extract-plugin
export default {"layerOne":"layer-one_layerOne__gpjTG","layerOneSvg":"layer-one_layerOneSvg__JlCAm","layerOneTreeSvg":"layer-one_layerOneTreeSvg__UuuZZ","gradient":"layer-one_gradient__Vsefh"};